/*!
 * Copyright (C) Microsoft Corporation. All rights reserved.
 */
export var oneLineHeight = 19;
//# sourceMappingURL=PowerFxFormulaEditor.types.js.map